import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const BabyBottleIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.4 2.6h3.2v2.1h-3.2z" />
    <rect x="8.6" y="4.7" width="6.8" height="2.2" rx="1" />
    <rect x="7.4" y="6.9" width="9.2" height="14.5" rx="2.8" />
    <path d="M10.2 11.5h2.4M10.2 14.6h2.4" />
  </svg>
)
